import {parseDate, formatDate, type ParsedDate} from "../util/DateUtil";
import {formatByteSize} from "../util/ByteSizeUtil";

export interface LibraryFunctions {
    oneOf: (value: any, ...possible: any) => boolean;
    parseDate: (val: string|null|undefined) => ParsedDate;
    formatDate: (date: Date | null, withTime: boolean, includeSeconds?: boolean) => string | null;

    /**
     * Map index to value. The index is used as key to object or index to array
     * and retrieved is returned.
     * Default value 'def' is returned if the index cannot be mapped to a value.
     */
    map(index:string|number, mapping: object|any[], def?:any):any;
	formatByteSize(size: number): string;
}

export function oneOf(value: any, ...possible: any): boolean {
    for (let p of possible) {
        if (value === p) return true;
    }
    return false;
}

function map(index:string|number, mapping: object|any[], def?:any):any {
    if (typeof index === "string") {
        // @ts-ignore
        if (Object.hasOwn(mapping, index)) return mapping[index];
    } if (Array.isArray(mapping) && typeof index === "number") {
        if (index >= 0 && index < mapping.length) return mapping[index];
    }
    return def;
}

const lib:LibraryFunctions = {
    oneOf,
    map,
    parseDate,
    formatDate,
	formatByteSize
};

export default lib;